// extracted by mini-css-extract-plugin
export var completionBody = "_bx-2";
export var completionCard = "_bx-0";
export var completionFooter = "_bx-3";
export var completionTitle = "_bx-1";